import { PRINCIPLES, PROCESS_STEPS } from "@/mocks/news";

export default function About() {
  return (
    <section id="about" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1.2fr_1fr] lg:items-start">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              About Us
            </p>
            <h3 className="font-heading mt-2 text-2xl font-bold text-foreground-950 md:text-3xl">
              关于每日爆料 · 投稿指南
            </h3>
            <p className="mt-4 text-[15px] leading-relaxed text-foreground-700">
              每日爆料网是一个面向全网的线索征集与议题跟进平台，连接普通人的真实遭遇与公共讨论。
              我们相信，真实的个体经历值得被认真对待。无论是一次糟心的消费维权、一处被忽视的民生问题，
              还是一条有价值的社会观察，都欢迎通过曝光台与我们分享。
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-foreground-700">
              收到线索后，编辑部会先核验事实、评估相关性，再决定是否进入跟进流程。我们始终坚持真实核实、
              来源保密、有误必纠，努力让每一条有价值的线索被看见、被推动。
            </p>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <h4 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-mail-send-line text-primary-600"></i>
              投稿联系方式
            </h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-700">
              <li className="flex items-start gap-3">
                <i className="ri-mail-line mt-0.5 text-primary-600"></i>
                <span>
                  官方邮箱：
                  <a href="mailto:liuyan@meiribaoliao.example" className="text-primary-700 hover:underline">
                    liuyan@meiribaoliao.example
                  </a>
                </span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-send-plane-line mt-0.5 text-primary-600"></i>
                <span>私信投稿：通过底部投稿表单或社交私信通道提供线索</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line mt-0.5 text-primary-600"></i>
                <span>处理时间：工作日内 3–5 个工作日，重大线索 24 小时内优先响应</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {PRINCIPLES.map((p) => (
            <div
              key={p.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${p.icon} text-xl`}></i>
              </span>
              <h4 className="mt-4 text-[17px] font-bold text-foreground-950">{p.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 rounded-lg bg-background-900 px-6 py-8 md:px-8 md:py-10">
          <div className="mb-8 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
            <h4 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
              一份线索如何被推进？
            </h4>
            <span className="text-sm text-background-50/60">从提交到反馈的完整流程</span>
          </div>
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {PROCESS_STEPS.map((s) => (
              <div key={s.step} className="relative rounded-lg bg-background-800 p-5">
                <span className="font-heading text-3xl font-bold text-accent-500">{s.step}</span>
                <h5 className="mt-3 text-[15px] font-semibold text-background-50">{s.title}</h5>
                <p className="mt-2 text-sm leading-relaxed text-background-50/65">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}